export const navigationGermanLocalization = {
  tabs: {
    start: 'Start',
    radio: 'Mein Ort',
    region: 'Meine Region',
    profile: 'Profil'
  },
  radioTabs: {
    title: 'Funkzentrale',
    sort: {
      title: 'Sortieren',
      lastActivity: 'Neuster Aktivität',
      created: 'Erstelldatum',
      happeningStart: 'Veranstaltungsdatum'
    },
    search: 'Suche',
    public: 'Beiträge',
    groups: 'Gruppen'
  }
};

// Guarantees that both translations have the same structure
type NavigationLocalization = typeof navigationGermanLocalization;

export const navigationEnglishLocalization: NavigationLocalization = {
  tabs: {
    start: 'Start',
    radio: 'My Place',
    region: 'My Region',
    profile: 'Profile'
  },
  radioTabs: {
    title: 'Local Hub',
    sort: {
      title: 'Sort',
      lastActivity: 'Last activity',
      created: 'Creation date',
      happeningStart: 'Event date'
    },
    search: 'Search',
    public: 'Posts',
    groups: 'Groups'
  }
};
